let Store = require("./Store")
let N721 = require("./N721")
let N1155 = require("./N1155")
if (window) {
    window.Store = Store
    window.N721 = N721
    window.N1155 = N1155
}

module.exports = {
    Store,N1155,N721
}